import LinkOutlinedIcon from "@mui/icons-material/LinkOutlined";

interface Props {
  svg?: string;
  size: number;
}

const ExternalLinkIcon = ({ svg, size }: Props) =>
  svg ? (
    <div
      style={{ width: size, height: size }}
      className="flex items-center justify-center"
    >
      <img
        src={`data:image/svg+xml;utf8,${encodeURIComponent(svg)}`}
        alt=""
        style={{ maxWidth: size, maxHeight: size }}
      />
    </div>
  ) : (
    <LinkOutlinedIcon style={{ fontSize: `${size}px` }} />
  );

export default ExternalLinkIcon;
